import { images, restaurant } from "../lib/data";

export const Story = () => {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative bg-[#f9f6f0] py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Text */}
        <div className="lg:col-span-6 reveal">
          <p className="overline text-[#5b7053]">Our Story</p>
          <h2 className="font-serif-display mt-6 text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-[#2c3528]">
            Fifteen summers
            <br />
            of <span className="italic text-[#5b7053]">filoxenia</span>.
          </h2>

          <div className="mt-10 space-y-6 text-[#2c3528]/85 text-lg leading-relaxed max-w-xl">
            <p>
              Tucked into the lanes of Planos&nbsp;Tsilivi, The Greek Yum
              Yum&rsquo;s opened its kitchen doors fifteen summers ago. What
              started as one family&rsquo;s table has grown into a taverna
              regulars from across Zakynthos quietly call &ldquo;home&rdquo;.
            </p>
            <p>
              Our owner{" "}
              <span className="font-medium text-[#2c3528]">
                {restaurant.owner}
              </span>{" "}
              still walks the market each morning — lemons from the orchard
              behind the church, oregano from the hillside, lamb from the
              farmer up the road. Then the coals are lit, the parchment is
              folded, and dinner begins to write itself.
            </p>
            <p className="font-serif-display italic text-2xl text-[#5b7053] leading-snug">
              &ldquo;You can taste the difference when food is cooked
              slowly,&nbsp;with patience.&rdquo;
            </p>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-8 border-t border-[#2c3528]/15 pt-8 max-w-lg">
            <div>
              <p className="font-serif-display text-5xl text-[#d98a6c] leading-none">
                15
              </p>
              <p className="mt-2 overline text-[#6a7465]">Years open</p>
            </div>
            <div>
              <p className="font-serif-display text-5xl text-[#d98a6c] leading-none">
                40+
              </p>
              <p className="mt-2 overline text-[#6a7465]">Family recipes</p>
            </div>
            <div>
              <p className="font-serif-display text-5xl text-[#d98a6c] leading-none">
                1
              </p>
              <p className="mt-2 overline text-[#6a7465]">Charcoal grill</p>
            </div>
          </div>
        </div>

        {/* Image collage */}
        <div className="lg:col-span-6 relative reveal">
          <div className="relative aspect-[4/5] w-full">
            <div
              aria-hidden
              className="absolute -top-6 -left-6 w-32 h-32 border border-[#d98a6c]/50 hidden md:block"
            />
            <img
              src={images.story}
              alt="The Greek Yum Yum's interior with traditional details"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute -bottom-8 -right-4 md:-right-10 bg-[#2c3528] text-[#f9f6f0] px-8 py-6 max-w-xs shadow-xl">
              <p className="overline text-[#f1c98a]">Since 2010</p>
              <p className="font-serif-display text-3xl mt-1 leading-tight">
                A family taverna
              </p>
              <p className="mt-2 text-sm text-[#f9f6f0]/75 italic">
                Tucked into the lanes of Tsilivi, Zakynthos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
